import useAchievementPanel from "../../hooks/achievements/useAchievementPanel";
import { TooltipWrapper } from "../common";
import "../../styles/achievementPanel.css";
import { useSiteSettings } from "../../hooks/useSiteSettings";

// AchievementsPanel component to display user achievements
const AchievementsPanel = () => {
  const { settings } = useSiteSettings();
  const {
    isMinimized,
    sortedAchievements,
    achievements,
    handleGoToAchievements,
    toggleMinimized,
    showUnlockedMessage,
    displayText,
    unlockedCount,
  } = useAchievementPanel();

  if (!settings.showAchievementsPanel) {
    return null;
  }

  return (
    <aside className={`achievements-panel fade-in ${isMinimized ? 'minimized' : ''}`} aria-label="Achievements panel">
      <header>
        <div className="header-content">
          <h3>
            {isMinimized && showUnlockedMessage 
              ? displayText 
              : isMinimized 
                ? ''
                : `Achievements (${unlockedCount}/${achievements.length})`
            } 
          </h3>
          <div className="header-buttons">
            {!isMinimized && (
              <TooltipWrapper title="Achievement room" position="bottom">
              <button 
                onClick={handleGoToAchievements}
                className="achievement-link-btn"
                aria-label="Go to achievements page"
              >
                🏆
              </button>
              </TooltipWrapper>
            )}
            <button 
              onClick={toggleMinimized}
              className={`minimize-btn achievement-hamburger ${isMinimized ? '' : 'open'}`}
              aria-label={isMinimized ? "Expand achievements" : "Minimize achievements"}
              aria-expanded={!isMinimized}
              aria-controls="achievements-list"
            >
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </button>
          </div>
        </div>
      </header>
      {!isMinimized && (
        <ul id="achievements-list">
          {sortedAchievements.map((a) => (
            <li key={a.id} className={a.unlocked ? "unlocked" : ""}>
              <div className="ach-row">
                <div className="meta">
                  <strong>{a.title}</strong>
                  <small>{a.desc}</small>
                </div>
                <div className="progress">
                  <div className="progress-bar" role="progressbar" aria-valuenow={a.progress} aria-valuemin="0" aria-valuemax={a.target} aria-label={`${a.title} progress`}>
                  <div 
                    className="progress-fill" 
                    style={{ width: `${Math.min(100, (a.progress / a.target) * 100)}%` }}
                  />
                  </div>
                  <span className="label">
                    {a.unlocked ? "Unlocked!" : `${a.progress}/${a.target} ${a.unit}`}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
};

export default AchievementsPanel;
